<div style="display: flex; flex-direction: column; align-items: center;">
  <span style="font-size: 14px; line-height: 25px;">{{ userCount }}</span>
  <span style="font-size: 12px; line-height: 12px;">{{userNames}}</span>
</div>
